module.exports = __webpack_public_path__ + "img/checkbox-error.afed3f22.svg";